if (!customElements.get('gift-packaging-confirmation')) {
  class GiftPackagingConfirmation extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.dialog = this.querySelector('[role="dialog"]');
      this.productTitle = this.querySelector('[data-existing-gift-title]');
      this.confirmButton = this.querySelector('[data-gift-confirm]');
      this.cancelButtons = this.querySelectorAll('[data-gift-cancel]');

      this.confirmButton?.addEventListener('click', () => this.finish(true));
      this.cancelButtons.forEach((button) => button.addEventListener('click', () => this.finish(false)));
      this.addEventListener('click', (event) => {
        if (event.target === this) this.finish(false);
      });
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.finish(false);
      });
    }

    request(productTitle) {
      if (this.pendingResolve) this.finish(false, false);

      this.productTitle.textContent = productTitle;
      this.previouslyFocused = document.activeElement;
      this.bodyWasLocked = document.body.classList.contains('overflow-hidden');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');

      if (typeof trapFocus === 'function') {
        trapFocus(this, this.cancelButtons[0] || this.dialog);
      } else {
        (this.cancelButtons[0] || this.dialog)?.focus();
      }

      return new Promise((resolve) => {
        this.pendingResolve = resolve;
      });
    }

    finish(confirmed, restoreFocus = true) {
      if (!this.hasAttribute('open')) return;

      const resolve = this.pendingResolve;
      this.pendingResolve = null;
      this.removeAttribute('open');
      if (!this.bodyWasLocked) document.body.classList.remove('overflow-hidden');

      if (restoreFocus) this.restoreFocus();
      resolve?.(confirmed);
    }

    restoreFocus() {
      const cartDrawer = this.previouslyFocused?.closest('cart-drawer.active');
      if (cartDrawer && typeof trapFocus === 'function') {
        trapFocus(document.getElementById('CartDrawer'), this.previouslyFocused);
      } else if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.previouslyFocused);
      } else {
        this.previouslyFocused?.focus();
      }
    }
  }

  customElements.define('gift-packaging-confirmation', GiftPackagingConfirmation);
}

window.confirmExtraGiftPackaging = (productTitle) => {
  const confirmation = document.querySelector('gift-packaging-confirmation');
  if (!confirmation) return Promise.resolve(false);

  return confirmation.request(productTitle);
};
